
import { useState } from "react";
import { Link, scroller } from "react-scroll";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const handleCTAClick = () => {
    setMenuOpen(false);
    if (isHomePage) {
      scroller.scrollTo("request-review", {
        smooth: true,
        spy: true,
        offset: -90,
      });
    } else {
      navigate("/#request-review");
    }
  };

  return (
    <header className="header">
      <div className="container header-content">
        <RouterLink
          to="/"
          className="header-brand"
          style={{ textDecoration: "none" }}
          onClick={(e) => {
            if (isHomePage) {
              e.preventDefault();
              scroller.scrollTo("hero", {
                smooth: true,
                spy: true,
                offset: -90,
              });
            }
          }}
        >
          <span className="header-logo">MUNAFA ENGINE</span>
          <span className="header-tagline">WEEKLY MUNAFA CLARITY FOR SALON OWNERS</span>
        </RouterLink>

        <button
          type="button"
          className="header-toggle"
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span aria-hidden="true">{menuOpen ? "✕" : "☰"}</span>
        </button>

        <nav className={`header-nav ${menuOpen ? "header-nav--open" : ""}`}>
          {isHomePage ? (
            <>
              <Link
                to="how-it-works"
                smooth={true}
                spy={true}
                activeClass="active"
                offset={-90}
                onClick={() => setMenuOpen(false)}
              >
                How It Works
              </Link>
              <Link
                to="what-you-see"
                smooth={true}
                spy={true}
                activeClass="active"
                offset={-90}
                onClick={() => setMenuOpen(false)}
              >
                What You See
              </Link>
              <Link
                to="faq"
                smooth={true}
                spy={true}
                activeClass="active"
                offset={-90}
                onClick={() => setMenuOpen(false)}
              >
                FAQ
              </Link>
            </>
          ) : (
            <>
              <RouterLink to="/" onClick={() => setMenuOpen(false)}>
                Home
              </RouterLink>
              <RouterLink to="/#how-it-works" onClick={() => setMenuOpen(false)}>
                How It Works
              </RouterLink>
              <RouterLink to="/#what-you-see" onClick={() => setMenuOpen(false)}>
                What You See
              </RouterLink>
              <RouterLink to="/#faq" onClick={() => setMenuOpen(false)}>
                FAQ
              </RouterLink>
            </>
          )}
        </nav>

        <button className="btn-header" onClick={handleCTAClick}>
          Get Weekly Clarity
        </button>
      </div>
    </header>
  );
}